import { Loader } from "@tql/ui-components-react/kendo/indicators";
import type { ReactNode } from "react";

import styles from "./status-banner.module.css";

type StatusBannerProps = {
	readonly title: ReactNode;
	readonly children?: ReactNode;
	readonly showLoader?: boolean;
};

export function StatusBanner({
	title,
	children,
	showLoader = true,
}: StatusBannerProps) {
	return (
		<div aria-live={"polite"} className={styles.statusBanner} role={"status"}>
			{showLoader ? (
				<span
					aria-hidden={"true"}
					className={styles.statusBannerLoader}
					data-testid={"status-banner-loader"}
				>
					<Loader size={"small"} type={"infinite-spinner"} />
				</span>
			) : null}
			<div className={styles.statusBannerContent}>
				<strong>{title}</strong>
				{children}
			</div>
		</div>
	);
}
